import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=2b165754&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=2b165754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b165754",
  null
  
)

export default component.exports